export default __webpack_public_path__ + "static/media/giresunImg.d266e12f.jpg";